import React from 'react';
import useStyles from './styles';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
//import {CurrencyFormats} from '../../utils/index';
import currencyFormatter from 'currency-formatter';

function Header({ amount, currency }) {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <div className={classes.header}>
      <div className={classes.content}>
        <div className={classes.contentWrapper}>
          <span className={classes.title}>{t('Total_payment')}</span>
          <span className={classes.amount}>
            {currency} {currencyFormatter.format(amount?.toFixed(2),{ code: '' })}
          </span>
        </div>
      </div>
    </div>
  )
}

Header.propTypes = {
  show: PropTypes.bool,
  amount: PropTypes.number,
  currency: PropTypes.string,
  logo: PropTypes.string
};

export default Header;
